import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import compose from '@shopify/react-compose'
import { withTranslation } from 'react-i18next'

import { ContentBox, Button, FormError, withConfiguration, withEndUser } from '@portal/kit/pkg/components'

import styles from './ran-activate-style'
import { isElligibleToFreeRan } from 'helpers/ran'

const RanActivate = props => {
  const classes = styles(props.theme)

  const freeRan = isElligibleToFreeRan(props)

  return (
    <Fragment>
      {props.error && <FormError message={props.error} /> }
      <ContentBox>
        <p className={classes.adTitle}>{props.t('ran_activate.title')}</p>
        <p className={classes.adText}>{props.t('ran_activate.text_1')}</p>
        <span className={classes.adImg} />
        <p className={classes.adText}>{props.t('ran_activate.text_2')}</p>
        <p className={classes.adAction}>
          {
            freeRan ?
            <Button onClick={props.activateRan}>{props.t('ran_activate.button')}</Button>
            :
            <Button to="/offers">{props.t('ran_activate.buy_button')}</Button>
          }
        </p>
      </ContentBox>
    </Fragment>
  )
}

RanActivate.propTypes = {
  activateRan: PropTypes.func.isRequired,
  portalConfiguration: PropTypes.object.isRequired,
  error: PropTypes.string,
}

export default compose(
  withTranslation(),
  withTheme,
  withEndUser,
  withConfiguration
)(RanActivate)
